
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import FaqSectionn from './FaqKeywordd';
import TestimonialSectionkey from './TestimonialSectionKeywordd';

function Punetoashtavinayakurbaniatour() {



  const cardData =
  {
    keyword: ' Pune to Ashtavinayak Urbania Tour Package',
    heading: 'Vaishnavi Travels: Pune to Ashtavinayak Urbania Tour Package',
    headingDescription: 'Vaishnavi Travels provides a convenient and reliable Pune to Ashtavinayak Urbania Tour Package, specially designed for devotees and families seeking a comfortable pilgrimage. Our Force Urbania is well-maintained with spacious push-back seating, powerful air-conditioning, modern interiors, and ample luggage space, ensuring a smooth and peaceful journey across all eight sacred Ashtavinayak temples. With experienced chauffeurs, timely pickups, and flexible booking options, we make your spiritual tour stress-free and well-organized. Whether traveling with family, friends, or groups, Vaishnavi Travels guarantees safe, comfortable, and dependable Urbania rental services for the complete Ashtavinayak Darshan tour from Pune.',

    top: 'Top Places to Visit in Ashtavinayak with Vaishnavi Travels',

"topPlaces": [
  {
    "title": "Shree Mayureshwar Mandir, Morgaon",
    "description": "Shree Mayureshwar Mandir in Morgaon (Pune district) is the first and most important Ashtavinayak temple. Dedicated to Lord Ganesha riding a peacock, the idol here is believed to have slain the demon Sindhu. The temple is built in black stone with four majestic gates symbolizing the four directions. Surrounded by a protective wall, it radiates ancient charm and power. Pilgrims begin and end the Ashtavinayak Yatra here. Mayureshwar is the spiritual gateway of the Ashtavinayak circuit."
  },
  {
    "title": "Shree Siddhivinayak Mandir, Siddhatek",
    "description": "Shree Siddhivinayak Temple at Siddhatek, situated on the banks of the Bhima River, is renowned as the place where Lord Vishnu obtained Siddhi from Ganesha. The swayambhu idol here is right-trunked, making it extremely rare and powerful. Pilgrims often perform pradakshina (circumambulation) of the hill around the temple, a practice considered highly auspicious. The temple’s peaceful setting enhances its spiritual aura. Siddhivinayak at Siddhatek is the temple of divine powers and blessings."
  },
  {
    "title": "Shree Ballaleshwar Mandir, Pali",
    "description": "Shree Ballaleshwar Temple in Pali, Raigad district, is unique as it is named after a devotee, Ballal, blessed by Lord Ganesha. The stone idol has diamond-studded eyes and is flanked by brass lamps burning continuously. The temple is designed to allow the morning sun’s rays to fall directly on the idol. Surrounded by scenic hills, it attracts thousands of pilgrims, especially during Ganesh Chaturthi. Ballaleshwar Mandir is a sacred symbol of unwavering devotion and divine grace."
  },
  {
    "title": "Shree Varadvinayak Mandir, Mahad",
    "description": "Shree Varadvinayak Temple in Mahad, Raigad district, is known as the Ganesha who grants boons. The idol here is swayambhu and covered in a silver sheet. Devotees are allowed to touch and offer prayers directly to the idol, which is rare in major temples. The temple has a holy pond, believed to have healing powers. The simple yet divine environment makes it a favorite among pilgrims. Varadvinayak is the temple of fulfilled wishes in the Ashtavinayak circuit."
  },
  {
    "title": "Shree Chintamani Mandir, Theur",
    "description": "Shree Chintamani Temple in Theur, Pune district, is associated with the legend of Lord Ganesha retrieving the Chintamani jewel for Sage Kapila. The idol is studded with precious stones and radiates calmness. Pilgrims visit here to free themselves from worries (‘chinta’). The temple’s architecture reflects Peshwa-era influences as it was patronized by Madhavrao Peshwa. The tranquil surroundings add to the spiritual charm. Chintamani at Theur is the remover of anxieties and bestower of peace."
  },
  {
    "title": "Shree Girijatmaj Mandir, Lenyadri",
    "description": "Shree Girijatmaj Temple in Lenyadri, near Junnar, is the only Ashtavinayak temple located in a cave. It is believed that Goddess Parvati performed penance here and Lord Ganesha was born as Girijatmaj. The temple is carved into a mountain and requires climbing 307 steps to reach. The hilltop offers stunning views of the valley. The peaceful cave interiors provide a unique spiritual experience. Girijatmaj at Lenyadri is the divine union of devotion, nature, and history."
  },
  {
    "title": "Shree Vighnahar Mandir, Ozar",
    "description": "Shree Vighnahar Temple in Ozar, Pune district, is dedicated to the Ganesha who removes obstacles (Vighnahar). The idol here is adorned with diamonds and emeralds. The temple is fortified with stone walls and has a deepa stambha (lamp tower) at its entrance. Pilgrims celebrate Ganesh Chaturthi and Ganesh Jayanti here with grandeur. The temple is situated on the banks of the Kukadi River, adding natural beauty to the spiritual atmosphere. Vighnahar of Ozar is the remover of life’s hurdles."
  },
  {
    "title": "Shree Mahaganapati Mandir, Ranjangaon",
    "description": "Shree Mahaganapati Temple at Ranjangaon is the most powerful of the Ashtavinayak temples. The idol is large and seated with ten trunks and twenty arms, though only part of it is visible to devotees. Legend says Lord Shiva himself worshipped this form of Ganesha before fighting Tripurasura. The temple was expanded by Madhavrao Peshwa, who installed the idol. It is considered the final stop of the pilgrimage. Mahaganapati of Ranjangaon is the grand protector of devotees."
  }
],


      "services": [
    {
      "name": "Urbania for Ashtavinayak Yatra",
      "description": "Embark on a spiritually fulfilling journey to the revered Ashtavinayak temples with our specialized Urbania van rental service from Pune. Designed for groups of all sizes, our vehicles provide comfortable seating, ample luggage space for pilgrimage essentials, and modern amenities to ensure a smooth and peaceful travel experience. Whether you are planning a family trip or a large group pilgrimage, our Urbania vans are ideal for visiting all eight sacred temples with ease, convenience, and safety."
    },
    {
      "name": "AC Urbania Pune to Ashtavinayak",
      "description": "Travel comfortably in our air-conditioned Urbania vans for your Pune to Ashtavinayak pilgrimage. Equipped with efficient cooling systems and ergonomic seating, these vans provide a refreshing escape from the heat, especially during long journeys. Perfect for devotees who prioritize comfort during religious travel, the AC Urbania offers a serene environment with low noise levels, clean interiors, and smooth suspension for an enjoyable darshan trip."
    },
    {
      "name": "13/17 Seater Force Urbania for Darshan",
      "description": "Our Force Urbania vans, available in 13 and 17 seater configurations, are perfectly suited for Ashtavinayak darshan trips. These sturdy vehicles are built for Indian roads, combining durability with passenger comfort. Spacious interiors, safety features, and reliable performance make them ideal for group travel. The vans come with GPS navigation, professional drivers familiar with the pilgrimage route, and ample storage for personal and religious items."
    },
    {
      "name": "Ashtavinayak Tour Bus Pune",
      "description": "Organize your Ashtavinayak temple tour with our dedicated Urbania bus rental service in Pune. Designed specifically for temple tours, our buses ensure punctual pickups, well-maintained vehicles, and experienced drivers who understand the importance of timely arrivals and departures. This service is popular among groups, schools, and religious organizations looking to cover all eight temples comfortably in a day or over a weekend."
    },
    {
      "name": "Family Trip Urbania Hire Ashtavinayak",
      "description": "Plan a memorable family pilgrimage to the Ashtavinayak temples with our spacious Urbania vans. These vehicles offer a safe and comfortable environment for travelers of all ages, including children and elderly family members. Equipped with safety belts, individual AC vents, and easy accessibility, the vans help families stay together throughout the trip. Personalized itinerary planning and flexible stopovers ensure your spiritual journey is hassle-free and enjoyable."
    },
    {
      "name": "Religious Travel in Urbania Pune",
      "description": "Choose our Urbania vans for all your religious travel needs from Pune. Whether it's the Ashtavinayak yatra, temple festivals, or spiritual retreats, our vans provide a dignified and comfortable mode of transport. Emphasizing cleanliness, punctuality, and courteous drivers, the service respects the sanctity of religious trips and strives to enhance the devotional experience with smooth transit and supportive amenities."
    },
    {
      "name": "Urbania Van with Driver Pune",
      "description": "Travel worry-free with our Urbania vans that come with experienced and professional drivers familiar with the Pune to Ashtavinayak pilgrimage route. Drivers are trained to handle group coordination, safety measures, and local road conditions. The package includes driver allowances, flexible scheduling, and support for special requests like temple parking and assistance with luggage, ensuring a seamless and stress-free trip."
    },
    {
      "name": "Outstation Urbania Tour Package Pune",
      "description": "Our outstation Urbania tour packages from Pune offer comprehensive solutions for multi-day Ashtavinayak yatra plans. Packages include vehicle rental, driver services, fuel, tolls, and customized itineraries covering all eight temples over a convenient timeframe. Ideal for groups wanting a well-organized pilgrimage with minimal logistical effort, this service guarantees comfort, safety, and timely travel throughout your religious expedition."
    },
    {
      "name": "Weekend Urbania Tour Ashtavinayak",
      "description": "Maximize your weekend with our special Urbania rental packages tailored for the Ashtavinayak pilgrimage. Travel from Pune to all eight temples over two days with comfort and ease, enjoying well-planned routes and rest stops. Our vans are equipped with all necessary amenities to ensure passenger well-being during the trip, including refreshment options and ample legroom for relaxation after darshan."
    },
    {
      "name": "Urbania Booking Pune to Ashtavinayak Temples",
      "description": "Conveniently book your Urbania van online for the Pune to Ashtavinayak temple tour. Our streamlined booking system allows you to select vehicle size, AC preferences, rental duration, and driver options, with instant confirmation and customer support. Perfect for last-minute plans or advance scheduling, the service provides transparent pricing and professional assistance to ensure your pilgrimage travel needs are fully met."
    },
    {
      "name": "Temple Tour in Urbania from Pune",
      "description": "Explore the Ashtavinayak temples and other sacred sites comfortably with our Urbania temple tour service. Tailored for devotees and tourists alike, this service offers personalized itineraries, flexible timings, and expert driver guidance. Whether it's a spiritual retreat or a cultural exploration, travel safely in modern vans equipped with all comfort features to make your temple tour memorable and hassle-free."
    },
    {
      "name": "Urbania Group Darshan Trip Pune",
      "description": "Organize a smooth and coordinated group darshan trip to the Ashtavinayak temples with our Urbania van rental. Perfect for religious societies, community groups, and tour operators, our vans ensure everyone travels together with sufficient space and amenities. We offer group discounts, multi-van options, and experienced drivers adept at managing group logistics and time-sensitive temple visits."
    },
    {
      "name": "Luxury Van for Pilgrimage Tour",
      "description": "Travel in style and comfort on your pilgrimage with our luxury Urbania vans designed for discerning travelers. Featuring premium interiors, leather seats, ambient lighting, and enhanced soundproofing, these vans make long religious journeys more pleasant. Additional amenities include onboard entertainment systems, chilled beverages, and multilingual drivers who provide attentive service, ensuring your spiritual tour is a memorable and rejuvenating experience."
    }
  ],
  "tableData": [
    ["Urbania for Ashtavinayak Yatra", "AC Urbania Pune to Ashtavinayak"],
    ["13/17 Seater Force Urbania for Darshan", "Ashtavinayak Tour Bus Pune"],
    ["Family Trip Urbania Hire Ashtavinayak", "Religious Travel in Urbania Pune"],
    ["Urbania Van with Driver Pune", "Outstation Urbania Tour Package Pune"],
    ["Weekend Urbania Tour Ashtavinayak", "Urbania Booking Pune to Ashtavinayak Temples"],
    ["Temple Tour in Urbania from Pune", "Urbania Group Darshan Trip Pune"],
    ["Luxury Van for Pilgrimage Tour"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Pune to Ashtavinayak Urbania Tour Package",
    "WhyChoosedescription": "Vaishnavi Travels offers comfortable and reliable Force Urbania vans for the Pune to Ashtavinayak pilgrimage tour, perfect for devotees and group travelers."
  },
  {
    "WhyChooseheading": "Spacious and Comfortable Seating",
    "WhyChoosedescription": "Our Urbania vans provide plush seats, ample legroom, and air conditioning to ensure a pleasant journey throughout the Ashtavinayak tour."
  },
  {
    "WhyChooseheading": "Well-Maintained and Sanitized Vehicles",
    "WhyChoosedescription": "Each vehicle is regularly serviced and thoroughly cleaned to maintain hygiene and safety during your spiritual journey."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with the Pilgrimage Route",
    "WhyChoosedescription": "Our professional drivers are knowledgeable about the Ashtavinayak circuit, ensuring timely and safe travel between the temples."
  },
  {
    "WhyChooseheading": "Flexible and Customized Tour Packages",
    "WhyChoosedescription": "Choose from half-day, full-day, or multi-day tour options tailored to your schedule and group preferences."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Our all-inclusive pricing covers fuel, tolls, driver allowance, and taxes for a hassle-free experience."
  },
  {
    "WhyChooseheading": "Ideal for Devotional Groups, Family Pilgrimages, and Corporate Retreats",
    "WhyChoosedescription": "Perfect for spiritual journeys, group tours, and customized travel experiences across the Ashtavinayak temples."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Easy Booking",
    "WhyChoosedescription": "Our customer service team is available round-the-clock to assist with bookings, itinerary planning, and travel support."
  }
]

























  }




const faqData = [
  [
    {
      question: 'Does Vaishnavi Travels offer 13 seater Force Urbania for Pune to Ashtavinayak tour packages?',
      answer: 'Yes, Vaishnavi Travels provides 13 seater Force Urbania vehicles for Pune to Ashtavinayak tours, perfect for group pilgrimages covering all eight Ashtavinayak temples comfortably.',
    },
    {
      question: 'What features make the 13 seater Force Urbania suitable for Pune to Ashtavinayak tours?',
      answer: 'The 13 seater Force Urbania offers spacious seating, air-conditioning, comfortable legroom, modern interiors, and ample luggage space, ensuring a comfortable and enjoyable pilgrimage experience.',
    },
    {
      question: 'Are the vehicles and drivers experienced for Ashtavinayak tour routes?',
      answer: 'Absolutely! All vehicles are well-maintained and regularly serviced. Our professional drivers are experienced, courteous, and knowledgeable about the Ashtavinayak temple routes and timings.',
    },
    {
      question: 'What is the rental cost for a Pune to Ashtavinayak Urbania tour package?',
      answer: 'Rental costs typically start from ₹7,000 for the full Ashtavinayak tour package, depending on the duration, distance, and any additional services required.',
    },
    {
      question: 'Can I customize the Pune to Ashtavinayak Urbania tour package?',
      answer: 'Yes, Vaishnavi Travels offers customizable tour packages to fit your schedule and preferences, including flexible pickup and drop-off points.',
    },
    {
      question: 'How early should I book the 13 seater Urbania for the Ashtavinayak tour?',
      answer: 'It is recommended to book at least 4-5 days in advance, especially during festival seasons and weekends, to ensure availability.',
    },
    {
      question: 'Is flexible pickup and drop-off available for Pune to Ashtavinayak Urbania tours?',
      answer: 'Yes, flexible pickup and drop locations are available in Pune and surrounding areas to best suit your pilgrimage plans.',
    }
  ]
];

const testimonials = [
  {
    name: "Mr. Deepak Shinde",
    position: "Pilgrim",
    feedback:
      "Our Ashtavinayak tour with Vaishnavi Travels in their 13 seater Urbania was a wonderful experience. The vehicle was spacious and comfortable, and the driver was very knowledgeable about the temple routes.",
    rating: 5,
  },
  {
    name: "Ms. Kavita More",
    position: "Devotee",
    feedback:
      "Vaishnavi Travels provided excellent service for our Pune to Ashtavinayak tour. The Urbania was well-maintained, and the driver was punctual and courteous throughout the journey.",
    rating: 5,
    style: "style-2",
  }
];




































































































  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Bus Booking for Marriage",
      link: "bus-booking-for-marriage"
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Bus Hire for Wedding in Pune",
      link: "bus-hire-for-wedding-in-pune"
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Bus Hire Near Me Pune",
      link: "bus-hire-near-me-pune"
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Bus Hire for Outstation",
      link: "bus-hire-for-outstation"
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Bus Service for Corporate Pune",
      link: "bus-service-for-corporate-pune"
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Bus Service for Corporate Events",
      link: "bus-service-for-corporate-events"
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Bus Service for Picnic in Pune",
      link: "bus-service-for-picnic-in-pune"
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Bus Rentals for School Trips in Pune",
      link: "bus-rentals-for-school-trips-in-pune"
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Bus Hire for School Trips in Pune",
      link: "bus-hire-for-school-trips-in-pune"
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Bus Rental for Tour Packages",
      link: "bus-rental-for-tour-packages"
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Bus on Rent for Event in Pune",
      link: "bus-on-rent-for-event-in-pune"
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Non AC Bus Rental Service in Pune",
      link: "non-ac-bus-rental-service-in-pune"
    },
    {
      place: "/images/keyword/13.jpg",
      text: "AC Bus On Rent in Pune",
      link: "ac-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Pune Local Bus on Rent",
      link: "pune-local-bus-on-rent"
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Bus On Rent in Pimpri Chinchwad",
      link: "bus-on-rent-in-pimpri-chinchwad"
    },
    {
      place: "/images/keyword/16.jpg",
      text: "25 Seater Tempo Traveller on Rent in Pune",
      link: "25-seater-tempo-traveller-on-rent-in-pune"
    },
    {
      place: "/images/keyword/17.jpg",
      text: "32 Seater Bus Rent in Pune",
      link: "32-seater-bus-rent-in-pune"
    },
    {
      place: "/images/keyword/18.jpg",
      text: "35 Seater Bus on Rent in Pune",
      link: "35-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/19.jpg",
      text: "40 Seater Bus on Rent in Pune",
      link: "40-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/20.jpg",
      text: "45 Seater Bus on Rent in Pune",
      link: "45-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/21.jpg",
      text: "50 Seater Bus on Rent in Pune",
      link: "50-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/22.jpg",
      text: "32 Seater Tempo Traveller Service",
      link: "32-seater-tempo-traveller-service"
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Mumbai Darshan Bus on Rent",
      link: "pune-to-mumbai-darshan-bus-on-rent"
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Shirdi Bus Hire",
      link: "pune-to-shirdi-bus-hire"
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Ganpatipule Beach Bus Rental Service",
      link: "pune-to-ganpatipule-beach-bus-rental-service"
    }
  ];


const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Ashtavinayak Urbania Tour Package",
  "image": "https://vaishnavitravel.com/assets/images/pune-to-ashtavinayak-urbania-tour.jpg",
  "description": "Book Urbania (13/17 Seater) for your Pune to Ashtavinayak pilgrimage tour. Comfortable AC van with driver, perfect for family trips, group darshan tours, and weekend religious travel.",
  "brand": {
    "@type": "Brand",
    "name": "Vaishnavi Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.95",
    "ratingCount": "420"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "6500",
    "availability": "https://schema.org/InStock",
    "url": "https://vaishnavitravel.com/pune-to-ashtavinayak-urbania-tour-package"
  }
};



  return (
    <div>

<Helmet>
  <title>Pune to Ashtavinayak Urbania Tour Package | 13/17 Seater AC Van Rental Pune</title>
  <meta
    name="description"
    content="Book Urbania (13/17 Seater) for your Pune to Ashtavinayak pilgrimage tour. Comfortable AC van with driver, perfect for family trips, group darshan tours, and weekend religious travel."
  />
  <meta
    name="keywords"
    content="Urbania for Ashtavinayak Yatra, AC Urbania Pune to Ashtavinayak, 13/17 Seater Force Urbania for Darshan, Ashtavinayak Tour Bus Pune, Family Trip Urbania Hire Ashtavinayak, Religious Travel in Urbania Pune, Urbania Van with Driver Pune, Outstation Urbania Tour Package Pune, Weekend Urbania Tour Ashtavinayak, Urbania Booking Pune to Ashtavinayak Temples, Temple Tour in Urbania from Pune, Urbania Group Darshan Trip Pune, Luxury Van for Pilgrimage Tour"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <section
        className="breadcrumb-wrapper fix bg-cover"
        style={{ backgroundImage: "url(/img/breadcrumb/breadcrumb.jpg)" }}>
        <div className="container">
          <div className="row">
            <div className="page-heading">
              <h2>{cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </section>


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/44.jpg' alt='img'  className='img-fluid'/>
              <h3 className="py-1"
                style={{
                  color: '#062349', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Vaishnavi Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vaishnavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">
                        <FaqSectionn idPrefix="faq-section-1" faqItems={faqData} />

                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionkey
                title="Our Clients Feedback"
                subtitle="Testimonial"
                testimonials={testimonials}
              />

              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919765685295" className="pc-call">+91 9765685295</a>
                      <a href="tel:+919881872524" className="pc-call">+91 9881872524</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919765685295"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919765685295" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@vaishnavitravel.com" className="pc-email">
                      booking@vaishnavitravel.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Vaishnavi Travels</strong><br />
                      Shop No 5, HQPJ+3J3, New DP Rd, near Cell Petroleum, Akshay Nagar Society, Nandanwan Society, Vishal Nagar, Pimple Nilakh, Pimpri-Chinchwad, Pune, Maharashtra 411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetoashtavinayakurbaniatour;